module.exports = __webpack_public_path__ + "static/presencial-menor-1-d063bd33d01f3f6cfe8e19c67ebe7567.jpg";